import { render, staticRenderFns } from "./LegalCategory.vue?vue&type=template&id=e1328ee6&scoped=true"
import script from "./LegalCategory.vue?vue&type=script&lang=ts"
export * from "./LegalCategory.vue?vue&type=script&lang=ts"
import style0 from "./LegalCategory.vue?vue&type=style&index=0&id=e1328ee6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1328ee6",
  null
  
)

export default component.exports